export default __webpack_public_path__ + "static/media/bg-card-03.d6cb5e3b.jpg";